import { TLabel } from '@apia/util';
import { CollectorLabel } from './Label';

export class CollectorTitle extends CollectorLabel {
  constructor(label: string | TLabel, level: number) {
    if (level < 1 || level > 6) {
      throw new Error('Only 1-6 leves allowed');
    }

    super(label, `h${level}` as 'h1');
  }
}
